import trackingClient from './client';
export const createTracker = trackingClient.createTracker;